import React from 'react';
import {
  Box,
  Button,
  InputAdornment,
  Menu,
  Stack,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import DialogHeader from '@shared/ui/dialog/DialogHeader';
import { currencySymbol } from './supplierLinkFormUtils';

const menuAnchorProps = {
  anchorOrigin: { vertical: 'bottom' as const, horizontal: 'right' as const },
  transformOrigin: { vertical: 'top' as const, horizontal: 'right' as const },
};

export interface PurchasePriceMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  currencyCode: string;
  purchasePrice: string;
  onChange: (value: string) => void;
}

const PurchasePriceMenu: React.FC<PurchasePriceMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onConfirm,
  title = 'Purchase price',
  currencyCode,
  purchasePrice,
  onChange,
}) => {
  const theme = useTheme();
  const sym = currencySymbol(currencyCode || 'EUR');

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      disableAutoFocusItem
      {...menuAnchorProps}
      PaperProps={{
        sx: { width: 320, maxWidth: 'calc(100vw - 24px)', mt: 0.5, overflow: 'hidden' },
      }}
    >
      <Box sx={{ p: 0 }} onClick={e => e.stopPropagation()}>
        <DialogHeader>
          <Typography variant="subtitle2">{title}</Typography>
        </DialogHeader>

        <Stack spacing={1} px={3} py={2}>
          <TextField
            type="number"
            value={purchasePrice}
            onChange={e => onChange(e.target.value)}
            inputProps={{ step: 0.01, min: 0 }}
            size="small"
            placeholder="0"
            fullWidth
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="body2" color="text.secondary">
                    {sym}
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          justifyContent="space-between"
          sx={{ p: 2, borderTop: 1, borderColor: theme.palette.divider }}
        >
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            Apply
          </Button>
        </Stack>
      </Box>
    </Menu>
  );
};

export default PurchasePriceMenu;
